"use client";

import { useEffect } from "react";
import { RefreshCw } from "lucide-react";

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@workspace/ui/components/alert";
import { Button } from "@workspace/ui/components/button";

/**
 * Falha que nao e de sessao (backend lento ou fora do ar). Antes ela mandava ao
 * login e parecia que o usuario tinha sido deslogado.
 */
export default function AdminError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[admin] erro ao carregar", error);
  }, [error]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <div className="w-full max-w-md space-y-4">
        <Alert variant="destructive">
          <AlertTitle>Não foi possível carregar o painel</AlertTitle>
          <AlertDescription>
            O servidor não respondeu como esperado. Tente novamente em
            instantes.
          </AlertDescription>
        </Alert>
        <Button className="w-full" onClick={reset}>
          <RefreshCw /> Tentar novamente
        </Button>
      </div>
    </main>
  );
}
